import {BaseContainerModel} from '../base-container.model';
import {app_perm_assignee_target_link_RowClass} from '../../dbschema/app_perm_assignee_target_link.model';

export class PermissionAssigneeTargetLinkContainerModel extends BaseContainerModel {
  permAssigneeTargetLink: app_perm_assignee_target_link_RowClass = new app_perm_assignee_target_link_RowClass();
}
